export default function EmpresaSection() {
  return (
    <section id="empresa" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          {/* Image */}
          <div className="w-full lg:w-[45%] flex-shrink-0">
            <div className="relative">
              <div className="absolute -top-4 -left-4 w-24 h-24 bg-[#E10600] rounded-lg opacity-20"></div>
              <div className="absolute -bottom-4 -right-4 w-32 h-32 border-4 border-[#E10600] rounded-lg opacity-30"></div>
              <a
                href="https://www.youtube.com/watch?v=8Zsw4lYVfXc"
                target="_blank"
                rel="nofollow noreferrer"
                className="block relative z-10 group"
              >
                <img
                  src="https://static.readdy.ai/image/ea473d33d180c87428df5c28ba90939d/51242ab77dfd6ae24b83ba39df14056a.png"
                  alt="Almacén Repuestos Octavio Ospina Sanchez"
                  className="w-full h-[320px] md:h-[420px] object-cover object-top rounded-xl cursor-pointer"
                />
                {/* Overlay oscuro al hover */}
                <div className="absolute inset-0 bg-black/30 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                {/* Botón de reproducción */}
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-16 h-16 flex items-center justify-center bg-white/20 backdrop-blur-sm border-2 border-white/70 rounded-full group-hover:scale-110 group-hover:bg-white/30 transition-all duration-300">
                    <i className="ri-play-fill text-white text-3xl ml-1"></i>
                  </div>
                </div>
              </a>
              {/* Badge */}
              <div className="absolute z-20 bottom-6 left-6 bg-[#E10600] text-white px-5 py-3 rounded-lg">
                <div className="text-2xl font-black">40+</div>
                <div className="text-xs font-semibold uppercase tracking-wide">Años de experiencia</div>
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="w-full lg:w-[55%]">
            <span className="text-[#E10600] text-xs font-black uppercase tracking-widest mb-3 block">
              Quiénes somos
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-black leading-tight mb-6">
              Más de 40 años de experiencia en repuestos <span className="text-[#E10600]">Mitsubishi</span>
            </h2>
            <p className="text-gray-600 text-base md:text-lg leading-relaxed mb-6">
              Somos un almacén especializado en <strong className="text-black">repuestos originales y homologados</strong> para vehículos Mitsubishi. Nuestra misión va más allá de vender una pieza: brindamos <strong className="text-[#E10600]">asesoría experta</strong> para encontrar no solo el repuesto, sino la <strong className="text-black">solución correcta</strong> para tu vehículo.
            </p>
            <p className="text-gray-600 text-base md:text-lg leading-relaxed mb-8">
              Con décadas de experiencia en el mercado colombiano, conocemos cada modelo, cada versión y cada detalle especializado de la línea Mitsubishi. Importamos repuestos que no se encuentren en el mercado local y procuramos la compatibilidad y la&nbsp; calidad en cada pieza que entregamos.
            </p>

            {/* Features */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {[
                { icon: "ri-shield-check-line", text: "Repuestos originales garantizados" },
                { icon: "ri-user-star-line", text: "Asesoría especializada" },
                { icon: "ri-truck-line", text: "Envíos a todo Colombia" },
                { icon: "ri-search-eye-line", text: "Importación de piezas especiales" },
              ].map((item) => (
                <div key={item.text} className="flex items-center gap-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-[#E10600]/10 rounded-lg flex-shrink-0">
                    <i className={`${item.icon} text-[#E10600] text-lg`}></i>
                  </div>
                  <span className="text-gray-700 font-medium text-sm">{item.text}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
